import { Space, Tag } from 'antd';
import moment from 'moment';
import { Smat } from '../../models';

export function SmatStatus(props: { smat?: Smat }) {
  let color: string | undefined = undefined;
  let status = 'Planlandı';

  if (props.smat?.status === 1) {
    status = 'Aktif';
  } else if (props.smat?.status === 2) {
    color = 'green';
    status = 'Tamamlandı';
  } else if (props.smat?.status === 3) {
    color = 'orange';
    status = 'Tamamlandı';
  } else if (props.smat?.status === 4) {
    color = 'red';
    status = 'Tamamlanmadı';
  }

  if (!props.smat) {
    return null;
  }

  return (
    <Space split="-">
      <Tag color={color}>{status}</Tag>
      {props.smat?.completedAt && <span>{moment(props.smat?.completedAt).format('DD.MM.yyyy HH:mm')}</span>}
    </Space>
  );
}
